//#region [IMPORT]

// === THIRD-PARTY ===
import React, { useState, useEffect, useContext } from 'react';

// === STYLE / MATERIAL UI ===
import { useTheme } from '@mui/material/styles';
import {
  Autocomplete,
  IconButton,
  TextField,
} from '@mui/material';
import { ExpandLess, ExpandMore } from '@mui/icons-material';

// === COMPONENTS ===
import { Spacer            } from 'components/Spacer';
import { ExpressionContext } from '../../../../../Context/ExpressionContext';
import { DataTypeSelect    } from '../../../DataTypeSelect/DataTypeSelect';
import { DocumentSelect    } from '../../../DocumentSelect/DocumentSelect';

// === UTILS ===
import { getHexAlpha } from 'components/styles.utils';

//#endregion

//-----------------------------------------------------------------
export function HasDocumentControls( props ) {
  //-----------------------------------------------------------------

  //#region [VALUES]

  const { updateExpression, fields } = useContext( ExpressionContext );

  const [ field_name, setFieldName ] = useState( fields   .find( x=> x.label   === props.data?.name   ) );
  const [ is_open   , setIsOpen    ] = useState( false );

  const expand_icon = is_open ? <ExpandLess /> : <ExpandMore />;

  //#endregion

  //#region [STYLES]

  const theme = useTheme();
  const _styles = {
    select_field: {
      width: '40rem',
    },
    button_add: {
      backgroundColor: theme.palette.primary[theme.palette.mode],
      color: 'white'
    },
    button_expand: {
      width  : '3rem',
      height : '3rem',
    },
  }

  const SELECT_FIELD = {
    sx          : _styles.select_field,
    id          : 'field-select',
    options     : fields,
    value       : field_name,
    size        : 'small',
    freeSolo    : true, 
    onChange    : onChange,
    renderInput : (params) => <TextField {...params} label="Field" />,
    getOptionLabel : (option) => option.label,
    disableClearable : true,
  };

  const BUTTON_EXPAND = {
    sx: _styles.button_expand,
    children: [expand_icon],
    onClick: () => { setIsOpen(!is_open) }
  };
    
  //#endregion

  //#region [EVENTS]
  
  //-----------------------------------------------------------------
  function onChange( event, value ) {
    //-----------------------------------------------------------------
    updateExpression( props.id , { name: value.value } )
  }
  
  //-----------------------------------------------------------------
  function onChange_Document( value ) {
    //-----------------------------------------------------------------
    updateExpression( props.id , { numcode: value.numcode } )
  }

  //#endregion

  //#region [DISPLAY]

  //-----------------------------------------------------------------
  function display() {
    //-----------------------------------------------------------------
    return (
      <>
        <div style={{display: 'flex'}}>
          <DataTypeSelect id={props.id} type={props.data?.type} />
          <Spacer />
          <div>
            <Autocomplete { ...SELECT_FIELD } />
            <div style={{ display: is_open ? '' : 'none' }}>
              <Spacer />
              <DocumentSelect onChange={onChange_Document} numcode={props.data?.numcode} />
            </div>
          </div>
          <Spacer />
          <IconButton { ...BUTTON_EXPAND } />
        </div>
      </>
    );
  }

  //#endregion

  return display();
}
